import {focusInputGroups} from "../../../default/global/js/checkInputGroups";
import {excludeModal, triggerModal} from "../../../default/global/js/modal";
import {initJumpmarks} from "../../../default/global/js/jumpmark";
import {initPhoneCountryFields} from "../../../default/global/js/phoneCountryField";
import {initInputMaskDate} from "../../../default/global/js/inputMaskDate";
import {initContentTabs} from "../../../default/global/js/contentTabs";
import {initScrollActivate} from "../../../default/global/js/scrollactivate";
import {initRecaptchaForms} from "../../../default/global/js/recaptchaForm";
import {maxHeightContent} from "../../../default/global/js/maxHeightContent";

window.addEventListener("load", (event) => {
    focusInputGroups();
    triggerModal();
    excludeModal();
    initJumpmarks();
    initPhoneCountryFields();
    initInputMaskDate();
    initContentTabs();
    initScrollActivate();
    initRecaptchaForms();
    maxHeightContent();
});
